// extracted by mini-css-extract-plugin
export default {"wrapper":"message_wrapper__Xrg-W"};